import { CellProps } from 'react-table'
import { LogsUsuarioActionsCell } from './LogsUsuarioActionsCell'
import { useQueryRequest } from '../../core/QueryRequestProvider'
import { TFunction } from '_metronic/i18n/Metronici18n'
import { PlainHeader, sortableColumn, StackedCell, TableColumn } from 'app/components'
import { UsuarioList } from 'app/modules/apps/admin/usuarios/usuarios-list/core/_models'

export const LogsUsuarioColumns = (t: TFunction): ReadonlyArray<TableColumn<UsuarioList>> => [
  // Nome com o e-mail como apoio (só o nome ordena).
  sortableColumn<UsuarioList>({
    id: 'pessoa.nome',
    useQueryRequest,
    fields: [
      { field: 'pessoa.nome', label: t('cols.nome') },
      { field: 'email', label: 'E-mail', sortable: false },
    ],
    Cell: ({ row }: CellProps<UsuarioList>) => (
      <StackedCell
        primary={row.original.nomeSocial || row.original.nome}
        secondary={row.original.email}
      />
    ),
  }),
  {
    Header: () => <PlainHeader>{t('cols.actions')}</PlainHeader>,
    id: 'actions',
    cellWidth: '96px',
    align: 'end',
    Cell: ({ row }: CellProps<UsuarioList>) => <LogsUsuarioActionsCell usuario={row.original} />,
  },
]
